// CacheKey 9ce4881fae95cd2257ca812ef69768cf
//
// DO NOT MODIFY: This file was automatically generated by JsFromTranslations.
export default {
  "en-UCSF_MEDICAL_CENTER": {
    simple_form: {
      labels: {
        patient: {
          aco_mssp_indicator: "ACO MSSP Indicator",
          other_insurance_indicator: "SFHP Flag"
        }
      }
    }
  }
}

